/**
 * Parses YAML frontmatter from a markdown string.
 * Supports simple key: value pairs, quoted strings, and inline arrays [a, b].
 */
export function parseFrontmatter(raw) {
  const match = raw.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/);
  if (!match) return { frontmatter: {}, content: raw.trim() };

  const frontmatter = {};
  for (const line of match[1].split('\n')) {
    const colon = line.indexOf(':');
    if (colon === -1) continue;
    const key = line.slice(0, colon).trim();
    const raw_val = line.slice(colon + 1).trim();
    if (!key) continue;

    if (raw_val.startsWith('[') && raw_val.endsWith(']')) {
      frontmatter[key] = raw_val
        .slice(1, -1)
        .split(',')
        .map((s) => s.trim().replace(/^["']|["']$/g, ''))
        .filter(Boolean);
    } else {
      frontmatter[key] = raw_val.replace(/^["']|["']$/g, '');
    }
  }

  return { frontmatter, content: match[2].trim() };
}
